<template>
  <div class="select">
    <select
      :name="name"
      :id="id"
      v-model="picked"
      @change="updateInput">
      <slot></slot>
    </select>
  </div>
</template>

<script>
export default {
  name: "vf-input-select",
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
      description: "ID of select input to make it unique"
    },
    selected: {
      required: true,
      description: "Value of selected option"
    },
  },
  data() {
    return {
      picked: this.selected
    }
  },
  methods: {
    updateInput(event) {
      this.$emit('input', event.target.value);
    }
  }
}
</script>

<style scoped lang="scss">

/* Reset Select */
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  box-shadow: none;
  border: 0 !important;
  background: rgba(#cad4dd, .42);
  background-image: none;
}
/* Remove IE arrow */
select::-ms-expand {
  display: none;
}
/* Custom Select */
.select {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  line-height: 3;
  overflow: hidden;
  border-radius: .25rem;
  border: 1px solid $border;

  @include lg {
  }

  @include rwd(992) {
    height: 45px;
  }
}
select {
  flex: 1;
  padding: 0 .5rem;
  color: $input-text-color;
  cursor: pointer;
}
/* Arrow */
.select::after {
  font-family: $icomoon-font-family;
  content: "\f107";
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 1rem;
  cursor: pointer;
  pointer-events: none;
  -webkit-transition: .25s all ease;
  -o-transition: .25s all ease;
  transition: .25s all ease;
  //font-size: 20px;
  color: rgba($gray, .79);
  line-height: 2.5rem;
}
/* Transition */
.select:hover::after {
  color: $secondary;
}


</style>
